import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'project-sprint-details-closed',
	template: require('./project.sprint.details.closed.html'),
})
export class ProjectSprintDetailsClosedComponent {
    @Input() parentCtrl: any;
    @Output() onUpdate: EventEmitter<any> = new EventEmitter();
}
